import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import UtilFunctions from '~utils/functions';

import { ErrorMessages } from '~utils/constants';
import { MetalTypeEnum } from '~utils/enums';

export default function* watchGetStockOuts(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetStockOutsAttempt', handleGetStockOuts, api);
}

function* handleGetStockOuts(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            dateFrom,
            dateTo,
            metalType,
            branchCode,
        },
    } = reduxState.gold.goldInventory.inventoryStockOutListing;

    if (!index && index !== 0) {
        yield put(combinedActions.goldGetStockOutsFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getStockOutListing], {
        authToken,
        index,
        dateFrom: dateFrom ? dateFrom : undefined,
        dateTo: dateTo ? dateTo : undefined,
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType) : undefined,
        branchCode: branchCode ? branchCode : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetStockOutsFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetStockOutsSuccess(response.data));
    }
}
